import { render } from 'preact';
import './styles/fonts.css';
import './styles/tokens.css';
import './styles/base.css';
import './styles/layout.css';
import './styles/print.css';
import { App } from './app.tsx';
import { dropLegacyCache } from './lib/legacy-cache.ts';

const root = document.getElementById('app');
if (!root) throw new Error('Missing #app root element');

render(<App />, root);

// Fire and forget: an old install's cache must not keep serving the previous
// index.html, but nothing on screen depends on the result.
void dropLegacyCache();
